import RequestAbstract from "../abstract";

export default class PartnerApiKeys extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/partner-api-keys";
    }
}
